import StencilHTMLElement from "./stencil-element";

class AgeGate extends StencilHTMLElement {
  name = "AgeGate";

  modal;
  button;

  constructor() {
    super();
  } 

  connectedCallback() {
    let modalElement = this.querySelector(".modal");
    this.button = this.querySelector('[data-name="btn-1"]');
    this.modal = new bootstrap.Modal(modalElement, {
      backdrop: false,
      keyboard: false
    });

    // Check if "age-gate:verified" is set to true in localStorage and show modal if not
    console.log(this.logPrefix, Shopify.designMode);
    if (localStorage.getItem("age-gate:verified") !== "true" && Shopify.designMode !== true) {
      this.modal.show();
    }

    // When the confirm button is clicked - set localstorage item and hide modal
    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      localStorage.setItem("age-gate:verified", "true"); // Set localStorage item
      this.modal.hide();
    });
  }
}

export default AgeGate;